export default {
  message_not_edited_error:
    'A mensagem n\u00e3o foi salva. Por favor, tente novamente.',
  CANCEL: 'Cancelar',
  SAVING: 'Salvando',
  generic_save: 'Salvar',
};
